import Vue from 'vue';
import VueMoment from 'vue-moment';
import moment from 'moment';

import 'moment/locale/fr';

Vue.use(VueMoment, { moment });

export default window.moment = moment;



// WEBPACK FOOTER //
// ./node_modules/@triotech/vue-core/src/vendor/moment.js